import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index.js'
// Amplify読み込み
import { AmplifyEventBus } from 'aws-amplify-vue'

// Viewのインポート
import HomeView from '../views/HomeView.vue'
import SendOpinionEmail from '../components/SendOpinionEmail.vue'
import AssessmentView from '../views/AssessmentView.vue'
import RecordView from '../views/RecordView.vue'
import RankingView from '../views/RankingView.vue'
import LoginView from '../views/LoginView.vue'

// Routerの使用
Vue.use(VueRouter)

// ログイン状態になったらstateにユーザーを設定
// ログアウト状態になったらstateにnullを設定
AmplifyEventBus.$on('authState', async (state) => {
  if (state === 'signedOut'){
      store.commit('setUser', null);
      router.push({path: '/'});
  } else if (state === 'signedIn') {
      await store.dispatch('getUser');
      router.push({path: '/'});
  }
});

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeView
  },
  {
    path: '/contact',
    name: 'SendOpinionEmail',
    component: SendOpinionEmail
  },
  {
    path: "/assessment",
    name: "Assessment",
    component: AssessmentView
  },
  {
    path: "/record",
    name: "Record",
    component: RecordView
  },
  {
    path: "/ranking",
    name: "Ranking",
    component: RankingView
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView
  }
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
